import React, { useEffect, useReducer, useState } from "react";
import { useParams } from "react-router-dom";
import { Row, Col, Card, CardHeader, Alert } from "reactstrap";
import { getCV, getPersonByUniStaffID } from "states/person/PersonDatasource";
import PersonReducer from "states/person/PersonReducer";
import { FETCH_SUCCESS, FETCH_FAILED } from "states/person/PersonType";
import imageExists from "image-exists";

import defaultAvatar from "assets/img/default-avatar.png";
import "./index.css";
import { ResearchSection, EducationSection, AwardSection } from "./section";
import PageLoading from "components/PageLoading";
import SubTemplate from "components/SubTemplate";
import JournalSection from "./section/JournalSection";

function BlockCV({ staffId }) {
  const [fileDL, setFileDL] = useState(false)

  useEffect(() => {
    const fetchCV = async (staffId) => {
      const resp = await getCV(staffId)

      if (resp.result) {        
        const link = process.env.REACT_APP_CV_DOWNLOAD + "?dl=" + resp.result.PDF_FILE_NAME
        setFileDL(link)
      }
    }

    fetchCV(staffId)
  })

  return (
    <>
      {
        fileDL && (
          <a href={fileDL} className="btn btn-block btn-info" target="_blank" rel="noreferrer">
            <i className="fas fa-file-alt"></i>
            <span> Download CV</span>
          </a>
        )
      }
    </>
  )
}

const INIT_DATA = {
  loading: true,
  data: null,
  itemsCount: 0,
};
function DetailContainer() {
  const [profileImage, setProfileImage] = useState(defaultAvatar);
  const [state, dispatch] = useReducer(PersonReducer, INIT_DATA);
  const { id } = useParams();

  const fetchData = async () => {
    try {
      const resp = await getPersonByUniStaffID(id, false);

      if (resp.status === 1) {
        const payload = {
          data: resp.result,
          itemsCount: resp.itemsCount,
        };
        setImage(resp.result.image);
        return dispatch({ type: FETCH_SUCCESS, payload });
      } else {
        return dispatch({ type: FETCH_FAILED, error: "Fetch failed" });
      }
    } catch (error) {
      return dispatch({ type: FETCH_FAILED, error: error.message });
    }
  };

  const renderNotice = () => {
    return (
      <Alert color="info">
        <i className="fa fa-info-circle"></i> <b>หากต้องอัพเดตข้อมูลส่วนตัว</b> เช่น รูปภาพ อีเมล หรือผลงานที่ต้องการเผยแพร่ สามารถแก้ได้ด้วยตนเองตามคู่มือการใช้
        <div className="text-center" style={{ marginTop: "5px", fontStyle: "normal" }}>
          <a className="btn btn-sm btn-secondary btn-block" href="https://cloud.eng.psu.ac.th/s/515C2q93sC2PM9h" target="_blank" rel="noreferrer"><i className="fa fa-fw fa-book"></i>คู่มือการใช้งาน</a>
        </div>
      </Alert>
    )
  }

  useEffect(() => {
    if (state.loading) {
      if (id) {
        setTimeout(() => {
          fetchData(id);
        }, 1000);
      } else {
        console.log("No id to query");
      }
    }
  });

  const setImage = (imageSource) => {
    imageExists(imageSource, (image) => {
      if (image) {
        setProfileImage(imageSource);
      } else {
        setProfileImage(defaultAvatar);
      }
    });
  };

  return (
    <SubTemplate displayName={state.data ? state.data.fullName : ""}>
      <div className="inner-container">
        <div className="content">
          {state.loading ? (
            <PageLoading />
          ) : (
            <Row>
              <Col lg={3} md={12}>
                <Card className="card-profile">
                  <CardHeader>
                    <i className="fas fa-user"></i>
                    <span> ข้อมูลส่วนตัว</span>
                  </CardHeader>
                  <Row>
                    <Col lg={12} md={5} sm={12}>
                      <div className="image">
                        <img
                          className="profile-image"
                          src={profileImage}
                          alt="img-profile"
                        />
                      </div>
                    </Col>
                    <Col lg={12} md={7} sm={12}>
                      <div className="detail">
                        <h5 className="name">{state.data.fullName}</h5>
                        <div>{state.data.fullNameEN}</div>
                        <div className="dept">{state.data.deptName}</div>
                        <dl className="dl-contact dl-horizontal">
                          <dt><i className="fas fa-phone-alt"></i> โทรศัพท์:</dt>
                          <dd>
                            {state.data.officeTel ? state.data.officeTel : "-"}
                          </dd>
                          <dt><i className="fas fa-at"></i> อีเมล: </dt>
                          <dd>{state.data.email ? state.data.email : "-"}</dd>
                          <dt><i className="fas fa-globe-americas"></i> website: </dt>
                            <dd>
                              <a href={state.data.website} target="_blank" rel="noreferrer">{state.data.website ? state.data.website : "-"}</a>
                            </dd>
                          <dt><i className="fab fa-facebook-f"></i> facebook: </dt>
                            <dd>
                              <a href={state.data.facebook} target="_blank" rel="noreferrer">{state.data.facebook ? state.data.facebook : "-"}</a>
                            </dd>
                            <dt><i className="fab fa-twitter-square"></i> twitter: </dt>
                            <dd>
                              <a href={state.data.twitter} target="_blank" rel="noreferrer">{state.data.twitter ? state.data.twitter : "-"}</a>
                            </dd>
                        </dl>                        
                        <BlockCV staffId={id} />
                      </div>                      
                    </Col>
                  </Row>
                </Card>
                <div className="section-helper">
                  {renderNotice()}
                </div>
              </Col>
              <Col lg={9} md={12}>
                <EducationSection staffId={id} />
                <ResearchSection staffId={id} />
                <JournalSection staffId={id} />
                <AwardSection staffId={id} />
              </Col>
            </Row>
          )}
        </div>
      </div>
    </SubTemplate>
  );
}
export default DetailContainer;
